import { render, staticRenderFns } from "./UpdateRecord.vue?vue&type=template&id=2d9b9d0e&"
import script from "./UpdateRecord.vue?vue&type=script&lang=js&"
export * from "./UpdateRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports